import styled from "styled-components";

import { Pill } from "../../../components/common/StyledComponents";

export const UpsellBadge = styled(Pill)`
  margin-left: 10px;
`;
